module.exports = __webpack_public_path__ + "img/workflow_automation_icon.44498c2e.svg";